import { useEffect, useState } from "react";
import { Activity } from "lucide-react";
import { adminApi } from "@/lib/api";

const PERIODS = [["7d", "Ultimi 7 giorni"], ["test", "Dal lancio del test"], ["all", "Totale"]];
const EVENTS = [
  ["itinerary_generated", "Itinerari generati"],
  ["itinerary_generation_error", "Errori di generazione"],
  ["email_request_completed", "Email inviate"],
  ["pdf_download", "PDF scaricati dal link"],
  ["affiliate_click", "Clic affiliati"],
];

export const EventsPanel = () => {
  const [period, setPeriod] = useState("7d");
  const [e, setE] = useState(null);
  useEffect(() => { adminApi.events(period).then(setE).catch(() => null); }, [period]);
  return (
    <div data-testid="admin-events" className="mb-10 rounded-3xl border border-emerald-100 bg-white p-6">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <p className="flex items-center gap-2 font-display text-xl font-semibold text-gray-900"><Activity className="h-5 w-5 text-emerald-600" />Eventi</p>
          <p className="text-sm text-gray-500">Gli stessi eventi inviati a Google Analytics 4, contati dal sito. Gli errori qui sono quelli dell'AI durante la generazione; i PDF aperti dall'allegato non sono misurabili.</p>
        </div>
        <div className="flex gap-2">{PERIODS.map(([k, l]) => (
          <button key={k} data-testid={`events-period-${k}`} onClick={() => setPeriod(k)}
            className={`rounded-full px-4 py-2 text-sm font-semibold transition-colors ${period === k ? "bg-emerald-600 text-white" : "bg-slate-50 text-gray-600 hover:bg-emerald-50"}`}>{l}</button>))}</div>
      </div>
      {e && (
        <div className="mt-5 grid gap-4 sm:grid-cols-2 lg:grid-cols-5">
          {EVENTS.map(([k, l]) => (
            <div key={k} data-testid={`event-${k}`} className="rounded-2xl bg-slate-50 p-4">
              <p className="text-xs font-semibold uppercase tracking-widest text-gray-500">{l}</p>
              <p className="mt-2 font-display text-3xl font-extrabold text-gray-900">{e[k]}</p>
              <p className="mt-1 break-all font-mono text-[11px] text-gray-400">{k}</p>
            </div>
          ))}
        </div>
      )}
      {!!e?.top_partners?.length && (
        <p data-testid="events-top-partners" className="mt-4 text-sm text-gray-600">Partner più cliccati: {e.top_partners.map((p) => `${p.partner} (${p.clicks})`).join(" · ")}</p>
      )}
    </div>
  );
};
